import Vue from 'vue'
import Router from 'vue-router'
import Catalog from '@/components/Catalog'
import Sales from '@/components/Sales'
import Information from '@/components/Information'
import CRM from '@/components/CRM'
import About from '@/components/About'
import Order from '@/components/Order'
import Login from '@/components/Login'
import Statement from '@/components/Statement'
import Transit from '@/components/Transit'
import Quiz from '@/components/Quiz'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: [
    {
      path: '/About',
      name: 'About',
      component: About,
      props: true,
      alias: '/'
    },
    {
      path: '/Catalog',
      name: 'Catalog',
      component: Catalog,
      props: true,
      alias: '/'
    },
    {
      path: '/Sales',
      name: 'Sales',
      component: Sales,
      props: true,
      alias: '/'
    },
    {
      path: '/transit',
      name: 'Transit',
      component: Transit,
      props: true,
      alias: '/'
    },
    {
      path: '/information',
      name: 'Information',
      component: Information,
      props: true,
      alias: '/'
    },
    {
      path: '/CRM',
      name: 'CRM',
      component: CRM,
      props: true,
      alias: '/'
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order,
      props: true,
      alias: '/'
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      props: true,
      alias: '/'
    },
    {
      path: '/Quiz',
      name: 'Quiz',
      component: Quiz,
      props: true,
      alias: '/'
    },
    {
      path: '/Statement',
      name: 'Statement',
      component: Statement,
      props: true,
      alias: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js